export enum MediaType {
  VIDEO = 'video',
  IMAGE = 'image',
  AUDIO = 'audio',
  PDF = 'pdf',
  OTHER = 'other',
}

const VIDEO_EXTENSIONS = ['mp4', 'mpg', 'mpeg'];
const IMAGE_EXTENSIONS = ['jpg', 'jpeg', 'png', 'gif'];
const AUDIO_EXTENSIONS = ['mp3'];
const PDF_EXTENSIONS = ['pdf'];

export function getFileExtension(file: string | File, defaultExtension = 'file') {
  if (!file) {
    return defaultExtension;
  }

  const filename = file instanceof File ? file.name : file;
  const extension = filename.includes('.') ? filename.split('.').pop() || defaultExtension : defaultExtension;

  return extension.toLowerCase();
}

export const getMediaType = (file: string) => {
  const extension = getFileExtension(file);

  if (VIDEO_EXTENSIONS.includes(extension)) {
    return MediaType.VIDEO;
  }

  if (IMAGE_EXTENSIONS.includes(extension)) {
    return MediaType.IMAGE;
  }

  if (AUDIO_EXTENSIONS.includes(extension)) {
    return MediaType.AUDIO;
  }

  if (PDF_EXTENSIONS.includes(extension)) {
    return MediaType.PDF;
  }

  return MediaType.OTHER;
};

export const downloadFile = (url: string, fileName?: string, target: string = '_blank') => {
  const hiddenAnchor = document.createElement('a');

  hiddenAnchor.style.display = 'none';
  document.body.appendChild(hiddenAnchor);
  hiddenAnchor.href = url;
  hiddenAnchor.target = target;
  hiddenAnchor.download = fileName || '';
  hiddenAnchor.click();
  window.URL.revokeObjectURL(url);
};
